import { useMsal } from "@azure/msal-react";
import style from "./LogoutSuccess.module.css";
import nerLogoLight from "../../assets/icons/NWR_logo_Light_Mood.svg";

const AccessDeniedComponent = ({ message }) => {
  const { instance } = useMsal();
  const displayMessage = message || "Access Denied!";

  const handleRelogin = () => {
    instance.loginRedirect();
  };

  return (
    <div className={style["shell"]}>
      <div className={style["signout-card"]}>
        <div className={style["logo"]}>
          <img src={nerLogoLight} alt="NetworkRail logo" />
        </div>

        <h1 className={style["heading"]}>{displayMessage}</h1>
        <p className={style["description"]}>
          Please contact your site administrator for assistance.
        </p>

        <p className={style["description"]}>
          Or try a different login{" "}
          <span
            onClick={handleRelogin}
            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
          >
            here
          </span>
          .
        </p>
      </div>
    </div>
  );
};

export default AccessDeniedComponent;
